import React from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import { useSectionColor } from '../context/SectionColorContext';

const Section = ({ sectionId, title, children, className = "" }) => {
  const { setActiveSection, currentColors } = useSectionColor();

  const { ref } = useInView({
    threshold: 0.6,
    onChange: (inView) => {
      if (inView) {
        setActiveSection(sectionId);
      }
    }
  });

  return (
    <motion.section 
      id={sectionId}
      ref={ref}
      className={`content-section ${className}`}
      style={{ 
        backgroundColor: '#000',
        minHeight: '100vh',
        color: currentColors.text
      }}
      transition={{ duration: 0.8 }}
    >
      <div className="section-content">
        <motion.h2 
          className="section-title"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
        >
          {title}
        </motion.h2>
        <motion.div
          className="section-body"
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          transition={{ duration: 1, delay: 0.2 }}
        >
          {children}
        </motion.div>
      </div>
    </motion.section>
  );
};

export default Section; 